import styled from 'styled-components';

export const DetailsList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-left: 0;
`;
